import React from 'react';
import _ from 'lodash';
import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import { InfoField } from './InfoField';
import { useDynamicFunction } from '../../services/hooks';
import { handleDynamicFunction } from '../../services/functions';

export const RadioChoiceField = props => {
  const { field, formik, getFieldCallback, yupRequiredFieldsCallback, bigFamilyCardCallback } = props;
  const dynamicFunction = useDynamicFunction(field.on_change);
  const debounced = useDebouncedCallback(
    val => {
      if (!_.isNil(dynamicFunction)) {
        const res = handleDynamicFunction(dynamicFunction, formik, field, val);
        if (res.callback) {
          props[res.callback](res.data, field.options.indexOf(val));
        }
      } else {
        formik.setFieldValue(field.name, val);
      }
    },
    300
  );

  return (
    <FormControl style={{ paddingBottom: 15 }}>
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
      </Typography>
      <RadioGroup
        row
        value={formik.values[field.name] || ''}
        onChange={e => debounced(e.target.value)
        }
      >
        { !_.isNil(formik.values[field.name])
          ? _.map(field.options, (name, key) => (
            <FormControlLabel
              value={name}
              key={key}
              control={<Radio />}
              label={name} />
          ))
          : null}
      </RadioGroup>
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
